var map = {
	"./SF-debile-22.mp3": "83d0",
	"./mining_bg.mp3": "9fa3",
	"./music_bg_1.mp3": "0a4c",
	"./sf-mouth-bouhbouhbouh_04.mp3": "60b6",
	"./sf_cartoon_ohoh_01.mp3": "a506",
	"./sf_cartoon_ohoh_02.mp3": "a789",
	"./sf_laugh_creature_04.mp3": "2231",
	"./sf_outch.mp3": "6179",
	"./sfx_chat_1.mp3": "7ae4",
	"./sfx_chat_2.mp3": "b837",
	"./sfx_chat_3.mp3": "8c74",
	"./sfx_chat_4.mp3": "d2ff",
	"./sfx_corrcet_answer.mp3": "95fd",
	"./sfx_enter_2.mp3": "c293",
	"./sfx_enter_3.mp3": "d724",
	"./sfx_oops.mp3": "e2c2",
	"./sfx_wrong_answer.mp3": "01b6",
	"./sfx_yay.mp3": "659a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba5b";